import { PROBLEM_CODES, errorMessage, isProblemError, problemCode } from "../../api";

/**
 * Le texte à montrer quand un geste sur une feuille est refusé. Les codes sont
 * ceux de `internal/adapter/in/http/errors.go` ; le texte, lui, est écrit ici
 * pour l'écran — le `detail` du serveur est un repli, pas une phrase d'interface.
 */
export function messageFeuille(err: unknown): string {
  switch (problemCode(err)) {
    case PROBLEM_CODES.timesheetLocked:
      return "Cette feuille est soumise : ses jours ne se modifient plus tant qu'elle n'a pas été traitée.";
    case PROBLEM_CODES.timesheetNotSubmitted:
      return "Cette feuille n'est plus en attente : elle a déjà été traitée.";
    case PROBLEM_CODES.timesheetInvalidTransition:
      return "Le statut actuel de la feuille ne permet pas ce geste.";
    case PROBLEM_CODES.timesheetEmpty:
      return "Déclarez au moins une demi-journée avant de soumettre.";
    case PROBLEM_CODES.timesheetFutureDay:
      return "Un jour à venir ne se déclare pas : la grille s'arrête à aujourd'hui.";
    case PROBLEM_CODES.timesheetInvalidDay:
      return "Un jour est hors du mois ou en double ; rechargez la feuille.";
    case PROBLEM_CODES.timesheetMonthInFuture:
      return "Une feuille ne s'ouvre pas sur un mois à venir.";
    case PROBLEM_CODES.timesheetReasonRequired:
      return "Indiquez un motif : le consultant doit savoir quoi corriger.";
    case PROBLEM_CODES.timesheetInexactAmount:
      return "Le tarif de l'expertise ne permet pas de valoriser cette feuille sans arrondi ; l'ESN doit corriger la grille.";
    case PROBLEM_CODES.notRecipient:
      return "Vous ne faites pas partie des destinataires des feuilles de temps de votre entreprise.";
    case PROBLEM_CODES.timesheetNotFound:
      return "Cette feuille n'existe pas, ou plus.";
    case PROBLEM_CODES.forbidden:
      return "Cette feuille n'est pas la vôtre.";
    default:
      return isProblemError(err) ? err.detail : errorMessage(err);
  }
}
